module.exports = __webpack_public_path__ + "static/img/audioBg.c1f665d9.png";